import React, { Component } from 'react';
import { Link } from 'react-router';

import '../../css/mobile-main-page.css';
import '../../css/mobile-landing.css';

import routeConfig from '../../config/route.json';

import $ from 'jquery';

class Landing extends Component {

  constructor(props) {
    super(props);
  }
  
  componentWillMount() {
    
  }

  componentDidMount() {
    let t = this;
    t.pageLoad();

    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();
  }

  changePositioning() {
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    
    $('#mobile-landing-button-en-p1').css({
      'height': windowWidth * 0.0568 + 'px',
      'top': windowWidth * 1.3 + 'px'
    });
    $('#mobile-landing-button-tc-p1').css({
      'height': windowWidth * 0.0568 + 'px',
      'top': windowWidth * 1.38888889 + 'px'
    });
    $('#mobile-landing-button-sc-p1').css({
      'height': windowWidth * 0.0568 + 'px',
      'top': windowWidth * 1.50241546 + 'px'
    });
  }
  
  render() {
    return <div className='mobile-main-page-container' style={{
    
    }}>
      <div className='mobile-main-page' style={{
        overflowX: 'hide'
      }}>
          <img className='mobile-main-page-bg' src='/p2/mobile/page/landing/main.png' style={{
            'transform': 'scale(1.15)'
          }}/>

          <Link onClick={this.resetHeaderFooter} to={routeConfig.home.en.mobileUrl}>
            <div className='mobile-landing-button' id='mobile-landing-button-en-p1' style={{
              'width': '18%',
              'left': '21.5%',
            }}>
              
            </div>
          </Link>
          <Link onClick={this.resetHeaderFooter} to={routeConfig.home.tc.mobileUrl}>
            <div className='mobile-landing-button' id='mobile-landing-button-tc-p1' style={{
              'width': '11%',
              'left': '25%',
            }}>
              
            </div>
          </Link>
          <Link onClick={this.resetHeaderFooter} to={routeConfig.home.sc.mobileUrl}>
            <div className='mobile-landing-button' id='mobile-landing-button-sc-p1' style={{
              'width': '11%',
              'left': '25%',
            }}>
              
            </div>
          </Link>

      </div>
    </div>
  }

};

export default Landing;



// WEBPACK FOOTER //
// ./src/mobile/page/Landing.js